/**
 * Tradução entre o formato da API e o formato do formulário do cadastro guiado.
 *
 * Fica fora do componente para poder ser testado: são as duas pontas em que um
 * erro silencioso muda o que o cliente vê na loja (ordem das variações e valores
 * das condições), sem estourar erro nenhum.
 */

/**
 * API → formulário.
 *
 * Aceita as duas formas em que os relacionamentos chegam: lista crua
 * (serializer de array, usado hoje) ou embrulhada em `{ data: [] }`.
 */
export function paraFormulario(dados) {
  if (!dados) return formularioVazio();

  const regras = dados.regras?.data || dados.regras || [];

  // A API devolve os campos na ordem do banco. Como a etapa de variações grava a
  // ordem pela posição do cartão, carregar fora de ordem reembaralharia
  // silenciosamente as opções que o cliente já vê hoje.
  const campos = [...(dados.campos?.data || dados.campos || [])].sort(
    (primeiro, segundo) => (primeiro.ordem ?? 0) - (segundo.ordem ?? 0)
  );

  return {
    id: dados.id ?? null,
    nome: dados.nome || "",
    descricao: dados.descricao || "",
    ativo: dados.ativo ? 1 : 0,
    regras: regras.map((regra) => ({
      colunaProduto: regra.coluna_produto || regra.colunaProduto,
      valor: regra.valor,
    })),
    campos: campos.map((campo, indice) => ({
      colunaProduto: campo.coluna_produto || campo.colunaProduto,
      labelCustomizado: campo.label_customizado || campo.labelCustomizado || "",
      ordem: campo.ordem ?? indice,
      // Preservado mesmo sem UI: há grupos com eixo gravado, e zerar aqui mudaria
      // a exibição da grade sem ninguém pedir.
      eixo: campo.eixo || null,
      ordenacao: campo.ordenacao || "natural",
      ordemValores: campo.ordem_valores || campo.ordemValores || [],
    })),
  };
}

/**
 * Formulário → payload de POST/PUT, no mesmo contrato que
 * App\Http\Requests\GrupoGradeRequest valida.
 */
export function paraPayload(form) {
  return {
    nome: (form.nome || "").trim(),
    descricao: (form.descricao || "").trim() || null,
    ativo: form.ativo ? 1 : 0,
    regras: (form.regras || []).map((regra) => ({
      colunaProduto: regra.colunaProduto,
      valor: String(regra.valor),
    })),
    // A ordem enviada é a posição do cartão na etapa de variações.
    campos: (form.campos || []).map((campo, indice) => ({
      colunaProduto: campo.colunaProduto,
      labelCustomizado: (campo.labelCustomizado || "").trim() || null,
      ordem: indice,
      eixo: campo.eixo || null,
      ordenacao: campo.ordenacao || "natural",
      ordemValores: (campo.ordemValores || []).map(String),
    })),
  };
}

export function formularioVazio() {
  return {
    id: null,
    nome: "",
    descricao: "",
    ativo: 1,
    regras: [],
    campos: [],
  };
}
